// extracted by mini-css-extract-plugin
export const posts = "blog-module--posts--2zbPx";
export const post = "blog-module--post--2yM5f";